export default __webpack_public_path__ + "static/media/VerificationCompany.6e011a4f.svg";